import React, { useRef, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/footer";
import Home from "./pages/Home";
import ErrorPage from "./pages/ErrorPage";
import Project from "./pages/Project";

function App() {
  const [isHome, setHome] = useState(true);
  const [nav, setnav] = useState(false);
  const about = useRef(null);
  const project = useRef(null);
  const contact = useRef(null);

  const scrollElement = (args) => {
    switch (args) {
      case "about":
        about.current.scrollIntoView({
          behavior: "smooth",
        });

        break;
      case "project":
        project.current.scrollIntoView({
          behavior: "smooth",
        });

        break;
      case "contact":
        contact.current.scrollIntoView({
          behavior: "smooth",
        });

        break;
      default:
    }
    setnav(false);
  };

  return (
    <Router>
      <NavBar
        scrollElement={scrollElement}
        nav={nav}
        setnav={setnav}
        setHome={setHome}
        isHome={isHome}
      />
      <Routes>
        <Route
          path="/"
          element={
            <Home
              about={about}
              project={project}
              contact={contact}
              isHome={isHome}
              setHome={setHome}
            />
          }
        />
        <Route
          path="*"
          element={
            <ErrorPage setHome={setHome} scrollElement={scrollElement} />
          }
        />
        <Route path="/project" element={<Project setHome={setHome} />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
